  <main class="content" style="text-align:center">
        <ng-content></ng-content>
  </main>
  